import { useEffect } from 'react';
import * as React from 'react';
import { DiilHeaderContext } from './DiilHeader';
const SectionProvider = () => {
    const { sso, postLoginRedirectUrl } = React.useContext(DiilHeaderContext);
    const [section, setSection] = React.useState(null);
    useEffect(() => {
        setSection(sso.ssoFrameVisible ? 'sso' : null);
    }, [sso.ssoFrameVisible]);
    const handleOpenSectionChange = (openSection, previousSection) => {
        if (previousSection === 'sso') {
            sso.setModalClosed();
        }
        if (openSection === 'sso') {
            if (!sso.isLoggedIn && !sso.dealer) {
                sso.setLoginParameters(postLoginRedirectUrl);
            }
            sso.setModalOpened();
        }
        setSection(openSection);
    };
    return { section, setSection, handleOpenSectionChange };
};
export default SectionProvider;
//# sourceMappingURL=SectionProvider.js.map